import React from 'react';
import '../../scss/_cost-data.scss';
import { AddRowActionsFooter, IAddRowAction } from './AddRowActions';

export interface ICostDataProps {
  addRowActions?: IAddRowAction[];
  className?: string;
  name?: string;
  simpleHeader?: boolean;
  style?: React.CSSProperties;
  hasEditPermissions?: boolean;
  children?: React.ReactNode;
}

export default class CostDataPurchase extends React.Component<ICostDataProps> {
  public static defaultProps: Partial<ICostDataProps> = {
    name: 'Name',
  };
  public render() {
    const { addRowActions, children, className, name, simpleHeader, style, hasEditPermissions } = this.props;
    return (
      <div className={`cost-data cost-data--purchase ${className || ''}`} style={style}>
        <div className="cost-data__row cost-data__aligned-row cost-data__header">
          {simpleHeader ? (
            <div className="cost-data__header-cell cost-data__header-simple-name">{name}</div>
          ) : (
            <React.Fragment>
              <div className="cost-data__header-cell cost-data__header-row-number">No.</div>
              <div className="cost-data__header-cell cost-data__header-name">{name}</div>
              <div className="cost-data__header-cell cost-data__header-amount">Amount</div>
              <div className="cost-data__header-cell cost-data__header-control" />
            </React.Fragment>
          )}
        </div>
        <div className="cost-data__body">{children}</div>
        {addRowActions && addRowActions.length ? (
          <AddRowActionsFooter addRowActions={addRowActions} disabled={!hasEditPermissions} />
        ) : null}
      </div>
    );
  }
}
